<app-information-naw [information]="information"></app-information-naw>
<app-information-program [information]="information"></app-information-program>
<app-information-fuses [information]="information"></app-information-fuses>
<app-information-network [information]="information"></app-information-network>
<app-information-linux [information]="information"></app-information-linux>
<app-information-rackxtender [information]="information"></app-information-rackxtender>
<app-information-fastlink [information]="information"></app-information-fastlink>

